export default __webpack_public_path__ + "static/media/Group 1614@2x.4bbcb9d0.png";